import { render, staticRenderFns } from "./GameListPage.vue?vue&type=template&id=ab141c6c&scoped=true&"
import script from "./GameListPage.vue?vue&type=script&lang=js&"
export * from "./GameListPage.vue?vue&type=script&lang=js&"
import style0 from "./GameListPage.vue?vue&type=style&index=0&id=ab141c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab141c6c",
  null
  
)

export default component.exports